import Typography from '@mui/material/Typography';
import { FC, memo } from 'react';

import { ImgProps } from '../types/img';

const Img: FC<ImgProps> = props => <Typography component='img' {...props} />;

export default memo(Img);
